


































































































































































































import { Component, Vue } from "vue-property-decorator";

import {
  HomeDayItemInterface,
  HomeHistoryItemInterface,
  HomeMealItemInterface,
  PolyDialogTypeInterface
} from "@/interfaces/index.ts";

import * as moment from "moment";

@Component({})
export default class HomePage extends Vue {
  toastMessage: string = "";
  toast: boolean = false;

  active: number = 0;

  tabTitle: string = "Today's plan";

  //// NEW CODE

  items: Array<HomeDayItemInterface> = [];
  historyItems: Array<HomeHistoryItemInterface> = [];
  historyItemSliceIndex: number = 0;
  historyListMaxIndex: number = 0;
  HISTORY_ITEMS_PER_SLIDE: number = 6;

  historyItemListChunks: Array<Array<HomeHistoryItemInterface>> = [];

  selectedItem: HomeDayItemInterface = {};
  selectedItemIndex: number = 2;

  selectedTimetableItemIndex: number = 0;
  selectedItemNotes: string = "";

  hourTimer: any;
  currentHour: number = 0;

  BREAKFAST_APPROACH_HOUR: number = 6;
  LUNCH_APPROACH_HOUR: number = 12;
  SUPPER_APPROACH_HOUR: number = 18;

  CHECK_TIME_MS: number = 1000 * 60 * 10;

  DIALOG_OPEN_EVENT = "OPEN_DIALOG";
  PAGE_DIALOG_EVENT = "HOME_PAGE_DIALOG";
  RANDOMIZE_EVENT = "RANDOMIZE_EVENT";

  // NEW CODE
  mounted() {
    this.setUpPageDialogListener();
    this.setUpRandomiseListener();

    this.fetch5DayDataFromDataService();
    this.fetchHistoryDataFromService();

    this.setHourWatch();

    setTimeout(() => {
      this.initialise();
    }, 1300);
  }

  async initialise(): Promise<void> {
    try {
      await this.$dataService.init();

      this.fetch5DayDataFromDataService();
      this.fetchHistoryDataFromService();
    } catch (e) {
      // Do nothing
    }
  }

  randomiseAndGet5DayData(): void {
    //@ts-ignore
    this.$dataService.randomiseWholeTimetableFromHomepage();
    this.fetch5DayDataFromDataService();
    this.fetchHistoryDataFromService();
    this.showToast("Changed your timetable order for you...");
  }

  fetch5DayDataFromDataService(): void {
    //@ts-ignore
    let items: Array<HomeDayItemInterface> = this.$dataService.get5DayData();
    items = items.map((item: HomeDayItemInterface, index: number) => {
      item.selected = index === this.selectedItemIndex;
      return item;
    });

    this.items = items;

    if (!this.items) return;

    this.selectedItem = this.items[this.selectedItemIndex];
    if (
      // @ts-ignore
      this.items[this.selectedItemIndex].items[this.selectedTimetableItemIndex]
    ) {
      // @ts-ignore
      this.selectedItemNotes = this.items[this.selectedItemIndex].items[
        this.selectedTimetableItemIndex
      ].notes;
    } else {
      this.selectedItemNotes = "";
    }
  }

  fetchHistoryDataFromService(): void {
    this.historyItems = [];
    //@ts-ignore
    this.historyItems = this.$dataService.getHistoryItems();

    this.splitHistoryListIntoChunks(this.historyItems);
  }

  humanizedMomentTime(date: Date): string {
    const pastDay = moment.default(date);
    const currentDay = moment.default(new Date());
    const numberOfDaysDifference = currentDay.diff(pastDay, "days");

    const humanizedTime =
      numberOfDaysDifference > 3
        ? moment.default(date, "DD-MM-YYYY").format("Do MMM YYYY")
        : moment.default(new Date(date)).fromNow();

    return humanizedTime;
  }

  splitHistoryListIntoChunks(
    historyList: Array<HomeHistoryItemInterface>
  ): void {
    // Restore to default
    this.historyItemListChunks = [];
    this.historyItemListChunks.push([]);
    let currentIndex = 0;
    for (let i = 0; i < historyList.length; i++) {
      const historyItem = historyList[i];

      this.historyItemListChunks[currentIndex].push(historyItem);

      const nextItemShouldBeInNewArray =
        (i + 1) % this.HISTORY_ITEMS_PER_SLIDE === 0;

      if (nextItemShouldBeInNewArray) {
        this.historyItemListChunks.push([]);
        currentIndex++;
      }
    }
    // Remove empty chunks
    this.historyItemListChunks = this.historyItemListChunks.filter(
      array => array.length > 0
    );

    // Update historyListMaxIndex
    this.historyListMaxIndex = this.historyItemListChunks.length - 1;

    // Clear lastIndex bug
    this.historyItemSliceIndex = this.historyItemListChunks[
      this.historyItemSliceIndex
    ]
      ? this.historyItemSliceIndex
      : this.historyItemListChunks.length - 1;
  }

  setHourWatch(): void {
    // Start by setting the currentHour
    this.currentHour = new Date().getHours();

    this.hourTimer = setInterval(() => {
      this.currentHour = new Date().getHours();
    }, this.CHECK_TIME_MS);
  }

  mealTimeIsNear(currentHour: number, timetableItemPosition: number): boolean {
    const itsNear =
      timetableItemPosition === 0
        ? currentHour >= this.BREAKFAST_APPROACH_HOUR
        : timetableItemPosition === 1
        ? currentHour >= this.LUNCH_APPROACH_HOUR
        : currentHour >= this.SUPPER_APPROACH_HOUR;

    return itsNear;
  }

  selectItem(item: HomeDayItemInterface): void {
    const currentItemIndex = this.items.findIndex(
      innerItem => innerItem.day === item.day
    );
    const foundItemIndex = this.items.findIndex(
      innerItem => innerItem.selected
    );

    this.items[foundItemIndex].selected = false;

    item.selected = true;

    this.selectedItem = this.items[currentItemIndex];
    if (
      this.selectedItem &&
      this.selectedItem.items &&
      this.selectedItem.items[0]
    )
      this.selectedItemNotes = this.selectedItem.items[0].notes as string;

    this.selectedItemIndex = currentItemIndex;
  }

  selectTimetableItem(item: HomeMealItemInterface): void {
    if (!(this.selectedItem && this.selectedItem.items)) return;

    const timetableItemSelectedIndex = this.selectedItem.items.findIndex(
      timetableItem => timetableItem.selected
    );

    this.selectedItem.items[timetableItemSelectedIndex].selected = false;

    item.selected = true;
    this.selectedItemNotes = item.notes as string;
    this.selectedTimetableItemIndex = this.selectedItem.items.findIndex(
      timetableItem => timetableItem.selected
    );
  }

  openDeleteHistoryConfirmationDialog(index: number) {
    const polyDialogData: PolyDialogTypeInterface = {
      isConfirmSelected: true,
      deleteHistoryItem: true,
      historyItemIndex: index
    };

    this.openDialog(polyDialogData);
  }

  openTimetableItemDialog(
    parentDate: number,
    currentIndex: number,
    timetableItem: HomeMealItemInterface
  ): void {
    const polyDialogData: PolyDialogTypeInterface = {
      timetableItemSelected: true,
      timetableItemValue: timetableItem.value,
      timetableItemParentDate: parentDate,
      timetableItemIndex: currentIndex
    };

    this.openDialog(polyDialogData);
  }

  openTimetableItemNotesDialog(selectedItem: HomeDayItemInterface): void {
    const currentlySelectedDayItemIndex = this.items.findIndex(
      parent => parent.date === selectedItem.date
    );

    const polyDialogData: PolyDialogTypeInterface = {
      timetableItemNotesSelected: true,
      timetableItemNotesValue: this.selectedItemNotes,
      timetableItemParentDate: this.items[currentlySelectedDayItemIndex].date,
      timetableItemIndex: this.selectedTimetableItemIndex
    };

    this.openDialog(polyDialogData);
  }

  handleTimeTableItemUpdate(update: PolyDialogTypeInterface): void {
    // Do service work later

    // Demonstration
    const currentParentIndex = this.items.findIndex(
      parent => parent.date === update.timetableItemParentDate
    );
    const itemToUpdate = this.items[currentParentIndex];

    // @ts-ignore
    this.$dataService.updateDayItemUpdateFromHomepage(itemToUpdate, update);

    // this.items[currentParentIndex].items![update.timetableItemIndex as number].value =
    //     update.updateValue;
  }

  handleTimeTableItemNotesUpdate(update: PolyDialogTypeInterface): void {
    // Do service work later

    // Demonstration
    const currentParentIndex = this.items.findIndex(
      parent => parent.date === update.timetableItemParentDate
    );
    const itemToUpdate = this.items[currentParentIndex];

    // @ts-ignore
    this.$dataService.updateDayItemNotesUpdateFromHomepage(
      itemToUpdate,
      update
    );

    // if (typeof update.timetableItemIndex === "number") {
    //   this.items[currentParentIndex].items![update.timetableItemIndex].notes =
    //     update.updateValue;
    //   this.selectedItemNotes = this.items[currentParentIndex].items![
    //     update.timetableItemIndex
    //   ].notes as string;
    // }
  }

  handleDeleteHistoryItem(update: PolyDialogTypeInterface): void {
    // Do service work later

    // Demonstration
    if (update.deleteHistoryItem) {
      this.historyItems.splice(update.historyItemIndex as number, 1);
      this.splitHistoryListIntoChunks(this.historyItems);
    }
  }

  handleUpdates(update: PolyDialogTypeInterface): void {
    // Timetable item updated
    if (update.timetableItemSelected) this.handleTimeTableItemUpdate(update);

    if (update.timetableItemNotesSelected)
      this.handleTimeTableItemNotesUpdate(update);

    if (update.deleteHistoryItem) this.handleDeleteHistoryItem(update);

    this.fetch5DayDataFromDataService();
    this.fetchHistoryDataFromService();
  }

  padDigit(size: number, digit: number): string {
    let str = String(digit);

    while (str.length < (size || 2)) str = "0" + str;

    return str;
  }

  getPaddedDayMonth(date: number): string {
    const month = new Date().getMonth() + 1;

    return `${this.padDigit(0, date)}/${this.padDigit(0, month)}`;
  }

  previousHistoryItems(): void {
    this.historyItemSliceIndex--;
  }

  nextHistoryItems(): void {
    this.historyItemSliceIndex++;
  }

  restoreFromHistoryItem(
    historyItem: HomeHistoryItemInterface,
    index: number
  ): void {
    if (index === 0) {
      this.showToast("This is your current state");
      return;
    }

    // @ts-ignore
    this.$dataService.restoreHistorySnapshot(historyItem);
    this.fetch5DayDataFromDataService();
    this.fetchHistoryDataFromService();

    this.showToast(`Restored`);
  }

  openDialog(data: PolyDialogTypeInterface): void {
    data.pageEvent = this.PAGE_DIALOG_EVENT;

    // const dialogType: PolyDialogTypeInterface = {
    //   timetableItemSelected: true
    //   // timetableItemNotesSelected: true
    //   // timetableSelected: true
    //   // addWeekSelected: true
    //   // removeWeekSelected: true
    //   // editTimetableItemSelected: true
    //   // signupSelected: true
    //   // loginSelected: true
    //   // isConfirmSelected: true
    //   // isLoadingSelected: true
    // };

    this.$root.$emit(this.DIALOG_OPEN_EVENT, data);
  }

  setUpPageDialogListener(): void {
    this.$root.$on(
      this.PAGE_DIALOG_EVENT,
      (update: PolyDialogTypeInterface) => {
        if (update) this.handleUpdates(update);
      }
    );
  }

  setUpRandomiseListener(): void {
    this.$root.$on(this.RANDOMIZE_EVENT, () => {
      this.randomiseAndGet5DayData();
    });
  }

  beforeDestroy() {
    if (this.hourTimer) clearInterval(this.hourTimer);
    this.$root.$off(this.RANDOMIZE_EVENT);
    // this.$root.$off(this.PAGE_DIALOG_EVENT)
    // this.$root.$off(this.DIALOG_OPEN_EVENT)
  }

  showToast(message: string): void {
    const simpleMessage = message.toLowerCase();

    if (
      simpleMessage.includes("typeerror") ||
      simpleMessage.includes("network")
    )
      return;
    else if (
      simpleMessage.includes("html") ||
      simpleMessage.includes("undefined")
    )
      message = "Please try again later";

    this.toastMessage = message;
    this.toast = true;
  }
}
